import { Grid, Typography } from '@mui/material'

import { CircleAlertIcon, SuccessOutlinedIcon } from 'src/assets/icons'

import { useStyles } from './styles'

interface IProps {
  text: string
  title: string
  status: 'success' | 'error'
}

export const ScanInfoCard = ({ text, title, status }: IProps) => {
  const classes = useStyles()

  return (
    <Grid className={classes.wrapper}>
      {status === 'success' ? (
        <SuccessOutlinedIcon className={classes.icon} />
      ) : (
        <CircleAlertIcon className={classes.icon} />
      )}
      <Grid>
        <Typography className={classes.title}>{title}</Typography>
      </Grid>
      <Grid>
        <Typography className={classes.text}>{text}</Typography>
      </Grid>
    </Grid>
  )
}
